import { render, staticRenderFns } from "./TokensSVG.vue?vue&type=template&id=627c9fbd"
import script from "./TokensSVG.vue?vue&type=script&lang=ts"
export * from "./TokensSVG.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports